import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
    selector: '[appLogAuditSeverityStyle]',
    standalone: false
})
export class LogAuditSeverityStyleDirective {

  @HostBinding('class') class = ''

  @Input() set level(level: string) {

    switch (level?.toLocaleLowerCase()) {
      case 'info': this.class = 'infoSeverity'; break
      case 'error': this.class = 'errorSeverity'; break
      case 'warning': this.class = 'warningSeverity'; break
      default: this.class = 'noSeverity'; break
    }

  }

  constructor() { }

}
